import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface LookFindrLogoProps {
  width?: string;
  height?: string;
  className?: string;
  onClick?: () => void;
}

const LookFindrLogo: FC<LookFindrLogoProps> = ({
  width = "172",
  height = "36",
  className,
  onClick,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 172 36"
      fill="none"
      className={" cursor-pointer  " + className}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <g clip-path="url(#clip0_1578_5635)">
        <path
          d="M26.8882 25.0595C26.8882 18.7347 31.3643 14.1562 37.5147 14.1562C43.6651 14.1562 48.1412 18.7347 48.1412 25.0595C48.1412 31.3844 43.6651 35.9628 37.5147 35.9628C31.3643 35.9628 26.8882 31.3855 26.8882 25.0595ZM37.5147 30.3863C40.1927 30.3863 42.1168 28.1359 42.1168 25.0179C42.1168 21.9 40.1927 19.6495 37.5147 19.6495C34.8367 19.6495 32.9126 21.9 32.9126 25.0179C32.9126 28.1359 34.8333 30.3863 37.5113 30.3863H37.5147Z"
          fill="#00086D"
        />
        <path
          d="M48.4731 25.0595C48.4731 18.7347 52.9492 14.1562 59.0996 14.1562C65.25 14.1562 69.7261 18.7347 69.7261 25.0595C69.7261 31.3844 65.2489 35.9628 59.0996 35.9628C52.9504 35.9628 48.4731 31.3855 48.4731 25.0595ZM59.0996 30.3863C61.7765 30.3863 63.7017 28.1359 63.7017 25.0179C63.7017 21.9 61.7765 19.6495 59.0996 19.6495C56.4228 19.6495 54.4975 21.9 54.4975 25.0179C54.4975 28.1359 56.4216 30.3863 59.0996 30.3863Z"
          fill="#00086D"
        />
        <path
          d="M77.0884 7.70215V22.6832L83.2771 15.1927H90.8115L83.2388 23.4326L91.6486 36.0001H84.4473L79.3478 27.6353L77.0884 30.0916V36.0001H71.2373V7.70215H77.0884Z"
          fill="#00086D"
        />
        <path
          d="M93.6559 14.2306V7.44216C93.6559 3.2395 96.7514 0.118164 100.935 0.118164C102.568 0.118164 104.492 0.576125 105.705 1.28276L104.031 6.44298C103.53 6.0694 102.609 5.77798 101.855 5.77798C100.517 5.77798 99.5126 6.77604 99.5126 8.10829V14.2306H111.927V19.3908H99.5126V36H93.6615V19.3908H90.4761V14.2306H93.6559Z"
          fill="#00086D"
        />
        <path
          d="M111.897 20.4453V36.0002H106.039V20.4453H111.897Z"
          fill="#00086D"
        />
        <path
          d="M124.444 20.3525C122.059 20.3525 120.26 22.4746 120.26 25.3462V35.9997H114.403V15.19H118.93L120.185 18.4363C121.19 16.2297 123.867 14.6904 126.628 14.6904C130.938 14.6904 133.908 18.4779 133.908 23.6797V35.9997H128.045V24.6801C128.045 22.1416 126.582 20.3525 124.444 20.3525Z"
          fill="#00086D"
        />
        <path
          d="M135.073 24.9903C135.073 18.706 139.048 14.0038 144.361 14.0038C145.481 13.9906 146.591 14.2178 147.616 14.6701C148.641 15.1223 149.556 15.7892 150.301 16.6255V7.01172H156.159V31.1486L156.242 35.8104H151.64L150.678 32.7307C149.13 34.6863 146.955 35.8104 144.361 35.8104C139.09 35.8104 135.073 31.1486 135.073 24.9903ZM145.7 30.1562C148.377 30.1562 150.301 27.9508 150.301 24.8677C150.301 21.7846 148.377 19.5792 145.7 19.5792C143.024 19.5792 141.097 21.7857 141.097 24.8677C141.097 27.9496 143.022 30.1562 145.7 30.1562Z"
          fill="#00086D"
        />
        <path
          d="M158.668 15.1903H163.187L164.312 18.1867C165.358 15.9813 167.115 14.6907 169.376 14.6907C170.13 14.683 170.876 14.8542 171.551 15.1903L170.547 21.4329C170.17 21.2664 169.501 21.1831 168.873 21.1831C166.321 21.1831 164.523 22.9306 164.523 25.5107V35.9977H158.665L158.668 15.1903Z"
          fill="#00086D"
        />
        <path
          d="M2.99778 35.8099L0.445801 30.4798C2.74753 29.3884 4.92342 28.0494 6.93489 26.4864C5.69687 24.3641 5.0768 21.938 5.14468 19.482C5.23245 15.3918 6.37341 11.0935 8.35941 7.37582C9.77605 4.72595 12.678 1.27605 16.1988 0.288116C17.1415 0.0110605 18.1313 -0.0686821 19.1062 0.0538658C20.0812 0.176414 21.0204 0.498621 21.8653 1.00037C23.4406 1.9208 24.4814 3.62887 24.7267 5.68463C25.2916 10.4499 23.9942 15.8655 19.6869 22.0542C18.3813 23.8871 16.9654 25.6389 15.4471 27.2999C18.4537 30.2255 21.1857 31.0626 25.1667 30.0815L26.0038 35.3013C20.6298 36.7123 14.5773 34.6026 10.9643 30.8455C8.50736 32.7995 5.83439 34.4652 2.99778 35.8099ZM18.2241 5.90292C18.0814 5.90529 17.9398 5.92763 17.8033 5.96931C16.3484 6.37776 14.5222 8.41326 13.5973 10.1461C12.0614 13.021 11.1421 16.4698 11.0745 19.6069C11.0481 20.5102 11.183 21.4109 11.4729 22.2669C12.4548 21.1777 13.3677 20.0281 14.206 18.8248C17.6154 13.9302 19.2121 9.62849 18.8194 6.38226C18.8064 6.2608 18.776 6.14182 18.7294 6.02894C18.5731 5.94801 18.4001 5.90485 18.2241 5.90292Z"
          fill="#00086D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1578_5635">
          <rect
            width="171.109"
            height="36"
            fill="white"
            transform="translate(0.445801)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LookFindrLogo;
